"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Text } from "@nxt-costco-com/forge-components";
import { CA_BC } from "../../../../../ProductTile/constants.js";
import { useProductTileData } from "../../../../../../../hooks/useProductTileData/index.js";
import { DeliveryChannelBadge } from "./DeliveryChannelBadge/index.js";
import { WarehouseChannelBadge } from "./WarehouseChannelBadge/index.js";
import { availabilityInfoWrapperStyles } from "./styles.js";
const AvailabilityInfo = () => {
  const { normalizedData, translationsConfig } = useProductTileData();
  const { availabilityInfoData, deliveryChannelData, productInfoData } = normalizedData;
  const { partNumber } = productInfoData;
  const { translations, keys, urls } = translationsConfig || {};
  const { samedayDeliveryIcon } = urls || {};
  return /* @__PURE__ */ jsxs(
    Box,
    {
      "data-testid": `AvailabilityInfo_${partNumber}`,
      sx: availabilityInfoWrapperStyles,
      children: [
        (availabilityInfoData == null ? void 0 : availabilityInfoData.inWarehouseAvailabilityText) && (keys == null ? void 0 : keys["productAPIClientId"]) === CA_BC && /* @__PURE__ */ jsx(Text, { uniqueId: `inWarehouseAvailability_${partNumber}`, children: (translations == null ? void 0 : translations.warehouseavailability) || "" }),
        deliveryChannelData && /* @__PURE__ */ jsx(
          DeliveryChannelBadge,
          {
            ...deliveryChannelData,
            translations,
            uniqueId: partNumber,
            samedayDeliveryIcon
          }
        ),
        (availabilityInfoData == null ? void 0 : availabilityInfoData.inWarehouseChannelBadgeData) && /* @__PURE__ */ jsx(
          WarehouseChannelBadge,
          {
            ...availabilityInfoData.inWarehouseChannelBadgeData,
            translations,
            uniqueId: partNumber
          }
        )
      ]
    }
  );
};
export {
  AvailabilityInfo
};
